<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
      <el-form-item label="产品标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入产品标题" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="产品副标题" prop="viceTitle">
        <el-input v-model="form.viceTitle" placeholder="请输入产品副标题" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="产品品牌" prop="brand">
        <el-input v-model="form.brand" placeholder="请输入产品品牌" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="运费" prop="freight">
        <el-input v-model="form.freight" placeholder="请输入运费" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="克拉数(1/10000Ct)" prop="integral">
        <el-input v-model="form.integral" :clearable="true" placeholder="请输入产品克拉数"></el-input>
      </el-form-item>
      <el-form-item label="产品状态">
        <el-select class="filter-item" v-model="form.state" placeholder="请选择" @change="selectValue">
          <el-option v-for="item in state" :key="item.index" :label="item.name" :value="item.index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="钻石品质等级">
        <el-select
          class="filter-item"
          v-model="form.qualityGrade"
          placeholder="请选择"
          @change="selecGrade"
        >
          <el-option
            v-for="item in gradeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品参数">
        <div v-for="(domain, index) in form.params" :key="index" style="margin-bottom: 10px;">
          <el-select
            class="filter-item"
            v-model="form.params[index].paramdts"
            placeholder="请选择"
            @change="selectParesms(form.params[index].paramdts,index)"
          >
            <el-option v-for="(item,i) in paramdter" :key="i" :label="item.name" :value="i"></el-option>
          </el-select>
          <el-input style="width:15%;margin-right: 10px;" v-model="form.params[index].value"></el-input>
          <el-button @click.prevent="addDomain()">添加</el-button>
          <el-button @click.prevent="removeDomain(domain)">删除</el-button>
        </div>
      </el-form-item>
      <el-form-item label="产品排序" prop="sort">
        <el-input v-model="form.sort" :clearable="true" placeholder="请输入产品排序"></el-input>
      </el-form-item>
      <el-form-item label="是否定制产品">
        <el-radio-group v-model="form.customize" @change="selectCustomized">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否在产品列表隐藏">
        <el-radio-group v-model="form.hide" @change="getHide">
          <el-radio :label="1">隐藏</el-radio>
          <el-radio :label="0">不隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="商品类型">
        <el-select class="filter-item" v-model="form.type" placeholder="请选择" @change="selectType">
          <el-option
            v-for="item in typeList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="商品类型">
        <el-radio-group v-model="form.type" @change="selectType">
          <el-radio :label="1" :disabled="disabledds">积分(克拉数)商品</el-radio>
          <el-radio :label="0" :disabled="disabledds">普通商品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="产品分类" prop="categoryId">
        <el-select class="filter-item" v-model="form.categoryId" placeholder="请选择">
          <el-option
            v-for="item in productClassification"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="封面图(最大不能超过2M)" required>
        <div style="display:flex" v-if="form.cover != null">
          <div class="imgs">
            <img
              :src="form.cover"
              alt
              style="width:145px;height:145px;margin-right: 10px;object-fit: cover;margin-bottom:10px"
            />
            <!-- <i @click="getClose(index)" class="el-icon-remove-outline icons"></i> -->
          </div>
        </div>
        <el-upload
          style="position: relative;"
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          :show-file-list="false"
          list-type="picture-card"
          :limit="10"
          :data="uploadData"
          :on-success="handleAvatarSuccess"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="详情图(单张图最大不能超过2M)" required>
        <div v-if="drawingImgs" style="display:flex">
          <draggable
            v-model="drawingImgs"
            @update="update2"
            :options="tplOptions"
            style="display:flex;flex-wrap: wrap;width: 1260px;"
          >
            <div v-for="(item, index) in drawingImgs" :key="index" class="imgs">
              <img
                :src="item"
                alt
                class="mover"
                style="width:145px;height:145px;margin-right: 10px;object-fit: cover;margin-bottom:10px"
              />
              <i @click="getClose(index)" class="el-icon-remove-outline icons"></i>
            </div>
          </draggable>
        </div>
        <el-upload
          style="position: relative;"
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          list-type="picture-card"
          :data="uploadData"
          :multiple="true"
          :on-success="getDetailDrawing"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload2"
          :show-file-list="false"
          :auto-upload="true"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="banner图(单张图最大不能超过2M)" required>
        <div v-if="drawingBanners" style="display:flex">
          <draggable
            v-model="drawingBanners"
            @update="update3"
            :options="tplOptions"
            style="display:flex;flex-wrap: wrap;width: 1260px;"
          >
            <div v-for="(item, index) in drawingBanners" :key="index" class="imgs">
              <img
                :src="item"
                style="width:145px;height:145px;margin-right: 10px;object-fit: cover;margin-bottom:10px"
              />
              <i @click="getCloseBa(index)" class="el-icon-remove-outline icons"></i>
            </div>
          </draggable>
        </div>
        <el-upload
          style="position: relative;"
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          list-type="picture-card"
          :data="uploadData"
          :on-success="getBanner"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload3"
          :show-file-list="false"
          :multiple="true"
          ref="imageUpload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="出售价"
        prop="price"
        :rules="[
      { required: true, message: '出售价不能为空', trigger: 'blur' },
    ]"
      >
        <el-input v-model="form.price" :clearable="true" placeholder="请输入出售价"></el-input>
      </el-form-item>
      <el-form-item
        label="市场价"
        prop="maxPrice"
        :rules="[
      { required: true, message: '市场价不能为空', trigger: 'blur' },
    ]"
      >
        <el-input v-model="form.maxPrice" :clearable="true" placeholder="请输入市场价"></el-input>
      </el-form-item>
      <el-form-item label="折扣状态" prop="vipDisStatus">
        <el-radio-group v-model="form.vipDisStatus" @change="getType">
          <el-radio :label="1" :disabled="disabledId">开启</el-radio>
          <el-radio :label="0" :disabled="disabledId">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="销售方式">
        <el-select
          class="filter-item"
          v-model="form.sellType"
          placeholder="请选择"
          @change="selectSale"
        >
          <el-option v-for="item in sales" :key="item.index" :label="item.name" :value="item.index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货方式">
        <el-select
          class="filter-item"
          v-model="form.deliveryMethod"
          placeholder="请选择"
          @change="selectGoods"
        >
          <el-option
            v-for="item in deliverGoods"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="工作日"
        v-if="dialogFormVisible"
        prop="deliveryDuration"
        :rules="[
      { required: true, message: '工作日不能为空', trigger: 'blur' },
    ]"
      >
        <el-input
          v-model="form.deliveryDuration"
          style="width:15%"
          placeholder="请输入工作日"
          :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="指定时间"
        v-if="dialogFormData"
        prop="deliveryTime"
        :rules="[
      { required: true, message: '请选择指定时间', trigger: 'change' },
    ]"
      >
        <el-date-picker
          v-model="form.deliveryTime"
          type="datetime"
          placeholder="选择日"
          @change="dataSearch"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="定时上架状态">
        <el-radio-group v-model="form.autoUpStatus" @change="getAutoUpStatus">
          <el-radio :label="1" :disabled="disabledAuto">开启</el-radio>
          <el-radio :label="0" :disabled="disabledAuto">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="定时上架时间" v-if="form.autoUpStatus == 1">
        <el-date-picker
          v-model="form.autoUpTime"
          type="datetime"
          placeholder="选择日"
          @change="dataAuto"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain class="iconad" @click="addItem">添加商品sku组合</el-button>
      </el-form-item>
      <div style="display:flex">
        <div class="divs">id</div>
        <div class="divs">sku图</div>
        <div class="divs inputs">
          <el-input :clearable="true" v-model="form.specTitle1" placeholder="尺寸"></el-input>
        </div>
        <div class="divs inputs">
          <el-input :clearable="true" v-model="form.specTitle2" placeholder="颜色"></el-input>
        </div>
        <div class="divs">库存</div>
        <div class="divs">销售价</div>
        <div class="divs" style="width:260px">兑换商品所需的克拉数(1/10000)</div>
        <div class="divs">市场价</div>
        <div class="divs">操作</div>
      </div>
    </el-form>
    <el-form label-width="0px" :inline="true" size="mini" class="formId">
      <div v-for="(item, index) in from.dynamicItem" :key="index">
        <el-form-item :prop="'dynamicItem.' + index + '.id'">
          <el-input id="input1" v-model="item.id" placeholder="请输入id"></el-input>
        </el-form-item>
        <el-form-item :prop="'dynamicItem.' + index + '.img'" style=" border: 1px solid #dcdfe6;">
          <el-upload
            style="position: relative;"
            class="avatar-uploader"
            :action="uploadUrl"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            :data="uploadData"
            :on-success="function(response, file){
              skuImg(response,file,index)
            }"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            v-model="item.img"
          >
            <div style="display: flex;align-items: center;margin-top:3px">
              <img
                :src="from.dynamicItem[index].img"
                alt
                style="width:42px;height:42px;margin-left: 55px;padding-top:0px;object-fit: cover;"
              />
              <i class="el-icon-plus avatar-uploader-icons" style="margin-left: 10px;"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :prop="'dynamicItem.' + index + '.specOne'">
          <el-input v-model="item.specOne" placeholder="请输入尺寸"></el-input>
        </el-form-item>
        <el-form-item :prop="'dynamicItem.' + index + '.specTwo'">
          <el-input v-model="item.specTwo" placeholder="请输入颜色组合"></el-input>
        </el-form-item>
<!--        <el-form-item :prop="'dynamicItem.' + index + '.wdNo'">-->
<!--          <el-input v-model="item.wdNo" placeholder="请输入旺店通编码"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item :prop="'dynamicItem.' + index + '.inventory'">
          <el-input v-model="item.inventory" placeholder="请输入库存数量"></el-input>
        </el-form-item>
        <el-form-item :prop="'dynamicItem.' + index + '.price'">
          <el-input v-model="item.price" placeholder="请输入销售价"></el-input>
        </el-form-item>
        <el-form-item :prop="'dynamicItem.' + index + '.pointAmount'" style="width:230px">
          <el-input
            style="width:230px"
            :disabled="form.type==0 ? true: numberList"
            v-model="item.pointAmount"
            placeholder="请输入积分兑换数量"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'dynamicItem.' + index + '.maxPrice'">
          <el-input v-model="item.maxPrice" placeholder="请输入市场价"></el-input>
        </el-form-item>
        <el-form-item style=" border: 1px solid #dcdfe6 ;width:155px">
          <div @click="deleteItem(item, index)" class="ceny">
            删除
            <i class="el-icon-delete"></i>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div class="footer" v-if="!editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定(新增)</el-button>
    </div>
    <div class="footer" v-else>
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getModify('form')">确 定(编辑)</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getClassificationd, getToken } from '@/api/demo/classification/index'
import { getAddd, getOption } from '@/api/demo/commodity/index'
import { getConfig, getInfo, getMEdit } from '@/api/demo/parameter/index'
import draggable from 'vuedraggable'
export default {
  name: 'commodityAdd',
  components: {
    draggable
  },
  data () {
    return {
      from: {
        id: null,
        img: null, // sku图
        inventory: null, // 库存
        maxPrice: null, // 市场价
        price: null, // 销售价
        specOne: null, // 规格1 	尺寸
        specTwo: null, // 规格2	颜色
        wdNo: null, // 旺店通编码
        pointAmount: null, // 积分兑换数量
        dynamicItem: []
      },
      numberList: false, //
      dialogFormVisible: false,
      dialogFormData: false,
      form: {
        title: '', // 产品标题
        viceTitle: '亲密马克', // 产品副标题
        brand: '亲密马克', // 产品品牌
        freight: 0, // 运费
        sort: '', // 排序
        integral: 0, // 产品积分 - 经验值
        state: 1, // 产品状态
        qualityGrade: -1, // 钻石等级品质
        customize: 1, // 是否定制产品
        hide: 0, // 是否在产品列表隐藏 1 隐藏 0 不隐藏
        type: 0, // 类型 普通商品
        maxPrice: '', // 市场价
        price: '', // 出售价
        specTitle1: '尺寸', // 规格名称1
        specTitle2: '颜色', // 规格名称2
        categoryId: '', // 产品分类
        cover: null, // 封面图
        detailImgs: null, // 详情图
        banner: null, // banner
        sellType: 1, // 销售方式
        deliveryMethod: null, // 发货方式
        deliveryDuration: null, // 当发货方式为1时取该值
        deliveryTime: null, // 当发货方式为2时取该值
        vipDisStatus: 0, // vip 折扣状态 1 开启 0 关闭
        skus: [],
        params: [{ value: '品牌', id: '', name: '', paramdts: 0 }], // 商品参数
        autoUpStatus: 0, // 定时上架状态 1 开启 0 关闭
        autoUpTime: null // 定时上架时间
      },
      disabledId: false, // 折扣判断状态
      disabledds: false, // 商品类型
      disabledAuto: false, // 定时上架状态
      value: null,
      rules: {
        title: [
          {
            required: true,
            message: '请输入产品标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur'
          }
        ],
        categoryId: [
          {
            required: true,
            message: '请选择产品分类',
            trigger: 'change'
          }
        ],
        brand: [
          {
            required: true,
            message: '请输入产品品牌',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur'
          }
        ]
      },
      state: [
        { index: 1, name: '上线' },
        { index: 0, name: '下线' }
      ],
      sales: [
        { index: 1, name: '现货' },
        { index: 2, name: '预售' }
      ],
      deliverGoods: [
        { index: 1, name: 'x个工作日内' },
        { index: 2, name: '指定时间按付款顺序发货' }
      ],
      productClassification: [],
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      https: null,
      drawingImg: '',
      drawingImgs: [], // 详情图
      // drawingBanner
      drawingBanner: '',
      drawingBanners: [],

      /** 模板配置 */
      tplOptions: {
        sort: true
      },
      // 时间
      disabledDate (time) {
        return time.getTime() > Date.now()
      },
      // 商品参数
      paramdter: [],
      paramdts: 0,
      selectId: null,
      selectName: null,

      // 接收id
      parametersId: null,
      product: {},

      editorialJudgment: false,
      judgeDomain: true,
      nameT: null,

      indexId: [],
      gradeList: [], // 钻石等级数据

      beforeArr: [],
      beforeArr2: [],
      dataList2: [],
      dataList: []
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  watch: {
    $route (to, from) {
      // this.getList();
    }
  },
  created () {
    let that = this
    getClassificationd({}).then(res => {
      that.productClassification = res
    })
    // this.initData()
    this.getparameter()

    // 产品信息
    this.parametersId = this.$route.query.id
    this.nameT = this.$route.query.name
    if (this.parametersId != undefined && this.nameT != '复制') {
      that.editorialJudgment = true
      that.getInformation()
    } else if (this.parametersId != undefined && this.nameT == '复制') {
      that.editorialJudgment = false
      that.getInformation()
    } else if (this.parametersId == undefined && this.nameT == null) {
      that.editorialJudgment = false
    }
    // 获取钻石品质等级选项
    this.getOptison()
  },
  mounted () {
    let that = this
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
  },
  methods: {
    // 获取钻石品质等级选项
    getOptison () {
      let that = this
      getOption({}).then(res => {
        that.gradeList = res
        that.gradeList.unshift({ key: -1, value: '灰色' })
        console.log('resdd', that.gradeList)
      })
    },
    // 取消
    cancel (formName) {
      this.$refs[formName].resetFields()
      this.$router.push('/demo/commodity')
    },
    // 产品状态
    selectValue (e) {
      this.form.state = e
    },
    // 钻石等级品质
    selecGrade (e) {
      this.form.qualityGrade = e
    },
    // 参数
    selectParesms (e, index) {
      this.paramdts = e
      this.form.params[index].id = this.paramdter[e].id
      this.form.params[index].name = this.paramdter[e].name
    },
    // 添加
    addDomain () {
      this.form.params.push({
        value: '',
        id: '',
        name: '',
        paramdts: ''
      })
      // console.log("this.form.params", this.form.params);
    },
    // 删除参数
    removeDomain (item) {
      var index = this.form.params.indexOf(item)
      if (index !== -1) {
        this.form.params.splice(index, 1)
      }
      console.log('this.form.params', this.form.params)
    },
    // 是否为定制 1是 0否
    selectCustomized (e) {
      this.form.customized = e
    },
    // 是否在产品列表隐藏 1 隐藏 0 不隐藏
    getHide (e) {
      this.form.hide = e
    },
    // 类型选择
    selectType (e) {
      let that = this
      that.form.type = e

      // if (that.form.type == 0) {
      //   that.numberList = true;
      // }
      console.log('that.numberList', e, that.form.type)
    },
    // 销售方式
    selectSale (e) {
      this.form.sellType = e
    },
    // 发货方式
    selectGoods (e) {
      this.form.deliveryMethod = e
      if (e == 1) {
        this.dialogFormVisible = true
        this.dialogFormData = false
      } else {
        this.dialogFormData = true
        this.dialogFormVisible = false
      }
    },
    // 七牛上传图片
    handleAvatarSuccess (res, file) {
      let that = this
      that.form.cover = that.https + '/' + res.key
    },
    // 详情图
    getDetailDrawing (res, file) {
      let that = this
      // 修改上传图片排序问题
      that.beforeArr2.filter((item, index) => {
        if (item.uid === file.uid) {
          // 与正确顺序的UID进行比对，添加进将要上传后台的数组
          that.drawingImg = that.https + '/' + res.key
          // 在前面添加进上传图片
          that.dataList2.splice(index, 1, that.drawingImg)
        }
      })
      var joo = that.dataList2.concat(that.drawingImgs)
      that.drawingImgs = joo
      that.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < that.drawingImgs.length; i++) {
          if (!obj[that.drawingImgs[i]]) {
            if (that.drawingImgs[i].name) {
            } else {
              result.splice(i, 0, that.drawingImgs[i])
              obj[that.drawingImgs[i]] = true
            }
          }
        }
        that.drawingImgs = result
        that.form.detailImgs = that.drawingImgs.join(',')
      })
    },
    // hku图
    skuImg (res, file, index) {
      let that = this
      console.log('that', that)
      this.$message({
        message: '上传成功!',
        type: 'success'
      })
      that.from.dynamicItem[index].img = that.https + '/' + res.key
      console.log('img', that.from.img)
    },
    // getBanner
    // 拖拽排序
    getBanner (res, file) {
      let that = this
      // 修改上传图片排序问题
      that.beforeArr.filter((item, index) => {
        if (item.uid === file.uid) {
          // 与正确顺序的UID进行比对，添加进将要上传后台的数组
          that.drawingBanner = that.https + '/' + res.key
          that.dataList.splice(index, 1, that.drawingBanner)
        }
      })
      console.log(that.drawingBanners, 'that.drawingBanners')
      var joo = that.dataList.concat(that.drawingBanners)
      that.drawingBanners = joo
      that.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < that.drawingBanners.length; i++) {
          if (!obj[that.drawingBanners[i]]) {
            if (that.drawingBanners[i].name) {
            } else {
              result.splice(i, 0, that.drawingBanners[i])
              obj[that.drawingBanners[i]] = true
            }
          }
        }
        that.drawingBanners = result
        that.form.banner = that.drawingBanners.join(',')
      })
    },
    beforeAvatarUpload (file) {
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
    },
    beforeAvatarUpload2 (file) {
      this.beforeArr2.push(file)
      this.dataList2.push(file)
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
    },
    beforeAvatarUpload3 (file) {
      this.beforeArr.push(file)
      this.dataList.push(file)
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
    },
    uploadError (err, file) {
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    // 详情图删除
    getClose (index) {
      this.drawingImgs.splice(index, 1)
      this.dataList2.splice(index, 1)
      this.beforeArr2.splice(index, 1)
      let strings = this.drawingImgs.join(',')
      this.form.detailImgs = strings
    },
    // Banner删除
    getCloseBa (index) {
      this.drawingBanners.splice(index, 1)
      this.dataList.splice(index, 1)
      this.beforeArr.splice(index, 1)
      let strings = this.drawingBanners.join(',')
      this.form.banner = strings
    },
    dataSearch (e) {
      this.form.deliveryTime = e
      console.log('e', this.form.deliveryTime)
    },
    // 上架时间
    dataAuto (e) {
      this.form.autoUpTime = e
      console.log('e', this.form.autoUpTime)
    },
    // sku
    addItem () {
      // let that = this
      this.from.dynamicItem.push({
        id: null,
        img: null, // sku图
        inventory: null, // 库存
        pointAmount: null, // 积分兑换数量
        maxPrice: null, // 市场价
        price: null, // 销售价
        specOne: null, // 规格1 	尺寸
        specTwo: null, // 规格2	颜色
        wdNo: null // 旺店通编码
      })
      this.form.skus = this.from.dynamicItem
      console.log('this.dynamicItem', this.form.skus)
    },
    deleteItem (item, index) {
      this.from.dynamicItem.splice(index, 1)
    },
    // 确定
    getCreate (form) {
      let that = this
      that.$refs[form].validate(valid => {
        if (valid) {
          getAddd(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '提交成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/commodity')
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 查询商品参数
    getparameter () {
      let that = this
      getConfig({}).then(res => {
        that.paramdter = res.records
        // console.log('that.paramdter',)
        that.form.params[0].id = that.paramdter[that.paramdts].id
        that.form.params[0].name = that.paramdter[that.paramdts].name
        console.log(that.form.params.id, that.form.params.name)
      })
    },
    // 产品信息
    getInformation () {
      let that = this
      getInfo(that.parametersId).then(res => {
        if (this.parametersId != undefined && this.nameT == '复制') {
          res.id = null
          for (let index = 0; index < res.skus.length; index++) {
            res.skus[index].id = null
            res.skus[index].spuId = null
          }
        }
        that.form = res
        that.form.categoryId = res.categoryId + ''
        that.from.dynamicItem = res.skus
        that.drawingImgs = that.form.detailImgs.split(',')
        console.log('ee', res)
        if (res.deliveryMethod == 1) {
          this.dialogFormVisible = true
          this.dialogFormData = false
        } else {
          this.dialogFormData = true
          this.dialogFormVisible = false
        }
        if (res.params == null) {
          res.params = [
            {
              createTime: '2021-08-27T17:10:47',
              id: 23,
              isDeleted: 0,
              name: '款号',
              updateTime: '2021-08-27T17:10:47',
              version: 1
            }
          ]
        }
        for (let index = 0; index < res.params.length; index++) {
          // that.indexId.push(res.params[index].id);
          for (let id = 0; id < that.paramdter.length; id++) {
            if (that.paramdter[id].id == res.params[index].id) {
              that.form.params[id].paramdts = id
            }
          }
        }
        that.drawingBanners = that.form.banner.split(',')
      })
    },
    // 编辑确定
    getModify () {
      let that = this
      console.log('img', that.from.img)
      getMEdit(that.parametersId, that.form).then(() => {
        that.$notify({
          title: '成功',
          message: '编辑成功',
          type: 'success',
          duration: 2000
        })
        that.$router.push('/demo/commodity')
      })
    },
    // 折扣状态
    getType (e) {
      let that = this
      that.form.vipDisStatus = e
      console.log('类型', e, that.form.vipDisStatus)
    },
    // 定时上架状态
    getAutoUpStatus (e) {
      let that = this
      that.form.autoUpStatus = e
      console.log('定时上架状态', e, that.form.autoUpStatus)
    },
    // 详情图拖拽
    update2 (e) {
      this.form.detailImgs = this.drawingImgs.join(',')
    },
    // banner图拖拽
    update3 (e) {
      this.form.banner = this.drawingBanners.join(',')
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.imgs {
  position: relative;
  cursor: move;
}
.icons {
  font-size: 24px;
  position: absolute;
  top: 45%;
  left: 47%;
  transform: translateX(-50%) translateY(-50%);
  color: red;
  display: none;
}
.imgs:hover .icons {
  transform: scale(0) 0.5;
  display: block;
}
.iconad {
  position: relative;
  left: -159px;
}
.divs {
  text-align: center;
  border: 1px solid #dcdfe6;
  font-size: 14px;
  line-height: 30px;
  color: #606266;
  width: 176px;
}
.el-form--inline .el-form-item {
  margin-right: 0px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0;
  width: 156.5px;
}
.el-input__inner {
  border-radius: 0;
}
.ceny {
  margin-left: 63px;
  height: 54px;
  line-height: 54px;
  color: red;
}
.inputs {
  width: 179px;
  border: none;
}
.formId >>> input {
  height: 56px;
}
</style>
